import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, eur, fmtDate, errMsg } from "@/lib/api";
import { useT } from "@/lib/i18n";
import { useAuth } from "@/context/AuthContext";
import { Loader, StatusBadge, Empty, Chip } from "@/components/common";
import { AlertTriangle } from "lucide-react";

export function BookingRow({ b }) {
  const { lang } = useT();
  const { user } = useAuth();
  return (
    <Link to={`/bookings/${b.id}`} className="w-card p-4 flex flex-wrap items-center justify-between gap-3 hover:bg-gray-50" data-testid={`booking-row-${b.id}`}>
      <div>
        <p className="font-bold">{user?.role === "provider" ? b.customer_name : b.provider_name} <span className="w-muted font-normal">· {b.code}</span></p>
        <p className="w-muted">{fmtDate(b.date, lang)} · {b.slot} Uhr · {b.kg} kg</p>
      </div>
      <div className="flex items-center gap-3 flex-wrap">
        {b.conflict_warning && user?.role === "provider" && b.status === "requested" && <Chip tone="warn"><AlertTriangle size={14} aria-hidden="true" /> Konflikt</Chip>}
        <StatusBadge status={b.status} />
        <span className="font-bold tabular-nums">{eur(b.price.total)}</span>
      </div>
    </Link>
  );
}

export default function Bookings() {
  const { t } = useT();
  const [items, setItems] = useState(null);
  const [error, setError] = useState("");
  useEffect(() => { api.get("/bookings").then((r) => setItems(r.data)).catch((e) => setError(errMsg(e))); }, []);
  return (
    <div className="w-container py-8 space-y-4">
      <h1 className="text-3xl font-extrabold">{t("bk.title")}</h1>
      {error && <p role="alert">{error}</p>}
      {!items && !error ? <Loader /> : items?.length === 0 ? <Empty>{t("bk.empty")} <Link className="underline font-semibold" to="/search">{t("nav.search")}</Link></Empty> : (
        <div className="space-y-3" data-testid="bookings-list">{items?.map((b) => <BookingRow key={b.id} b={b} />)}</div>
      )}
    </div>
  );
}
